import {z} from '@hono/zod-openapi';

const serviceIntervalSummaryDueWorkSchema = z.object({
  workName: z.string(),
  intervalKm: z.number().nullish(),
  normTimeHours: z.number().nullish(),
});

const serviceIntervalSummaryUpcomingWorkSchema = z.object({
  workName: z.string(),
  atMileage: z.number().nullish(),
  requiresClarification: z.boolean(),
});

const serviceIntervalSummaryPartsCalloutSchema = z.object({
  priceRangeFrom: z.number().nullable(),
  priceRangeTo: z.number().nullable(),
  requiredPrCodes: z.array(z.string()),
});

export const serviceIntervalSummaryRequestSchema = z.object({
  // Human language name the summary should be written in (e.g. "Czech").
  language: z.string(),
  vehicle: z.object({
    model: z.string().nullish(),
    variant: z.string().nullish(),
  }),
  currentMileage: z.number(),
  nextServiceMileage: z.number().nullable(),
  estimatedWorkHoursNow: z.number().nullable(),
  dueNow: z.array(serviceIntervalSummaryDueWorkSchema),
  upcoming: z.array(serviceIntervalSummaryUpcomingWorkSchema),
  partsCallout: serviceIntervalSummaryPartsCalloutSchema.nullable(),
});

export type ServiceIntervalSummaryRequest = z.infer<typeof serviceIntervalSummaryRequestSchema>;
